// dealingMockData.js — All mock data for T-bill dealroom

// ─── CSD Accounts ──────────────────────────────────────────────────────
export const CSD_ACCOUNTS = [
  {
    id: 'CSD-KE-001',
    entityId: 'ENT-001',
    entityName: 'Impact Capital Partners',
    market: 'KE',
    csdAccountNo: 'KE-CDS-2024-4471',
    status: 'active',
    nettingEnabled: true,
    openedDate: '2024-03-15',
    kycStatus: 'verified',
    balance: { face: 125000000, marketValue: 121850000, currency: 'KES' },
  },
  {
    id: 'CSD-KE-002',
    entityId: 'ENT-002',
    entityName: 'Global Green Fund',
    market: 'KE',
    csdAccountNo: null,
    status: 'pending_csd',
    nettingEnabled: false,
    openedDate: null,
    kycStatus: 'pending',
    balance: { face: 0, marketValue: 0, currency: 'KES' },
  },
  {
    id: 'CSD-KE-003',
    entityId: 'ENT-002',
    entityName: 'Global Green Fund',
    market: 'KE',
    csdAccountNo: null,
    status: 'blocked',
    nettingEnabled: false,
    openedDate: null,
    kycStatus: 'pending',
    blockerReason: 'Local mobile number required for M-Pesa settlement',
    balance: { face: 0, marketValue: 0, currency: 'KES' },
  },
  {
    id: 'CSD-KE-004',
    entityId: 'ENT-003',
    entityName: 'Individual Account — Michael Chen',
    market: 'KE',
    csdAccountNo: 'KE-CDS-2025-0892',
    status: 'active',
    nettingEnabled: false,
    openedDate: '2025-06-10',
    kycStatus: 'verified',
    balance: { face: 8500000, marketValue: 8280000, currency: 'KES' },
  },
];

// ─── Auction History per Tenor ─────────────────────────────────────────
const YIELD_HISTORY_91 = [
  { date: '2024-03-14', way: 16.48, cutoff: 16.50, bidCover: 2.12 },
  { date: '2024-09-12', way: 15.92, cutoff: 15.95, bidCover: 1.95 },
  { date: '2025-03-13', way: 12.10, cutoff: 12.15, bidCover: 2.31 },
  { date: '2025-09-11', way: 10.05, cutoff: 10.10, bidCover: 2.48 },
  { date: '2026-03-12', way: 9.20, cutoff: 9.25, bidCover: 2.65 },
  { date: '2026-08-27', way: 8.72, cutoff: 8.78, bidCover: 2.81 },
];

const YIELD_HISTORY_182 = [
  { date: '2024-03-14', way: 16.82, cutoff: 16.90, bidCover: 1.88 },
  { date: '2024-09-12', way: 16.20, cutoff: 16.28, bidCover: 1.75 },
  { date: '2025-03-13', way: 12.85, cutoff: 12.90, bidCover: 2.10 },
  { date: '2025-09-11', way: 10.55, cutoff: 10.62, bidCover: 2.22 },
  { date: '2026-03-12', way: 9.60, cutoff: 9.65, bidCover: 2.40 },
  { date: '2026-08-27', way: 9.08, cutoff: 9.14, bidCover: 2.55 },
];

const YIELD_HISTORY_364 = [
  { date: '2024-03-14', way: 16.95, cutoff: 17.00, bidCover: 1.62 },
  { date: '2024-09-12', way: 16.48, cutoff: 16.55, bidCover: 1.55 },
  { date: '2025-03-13', way: 13.20, cutoff: 13.28, bidCover: 1.90 },
  { date: '2025-09-11', way: 10.85, cutoff: 10.92, bidCover: 2.05 },
  { date: '2026-03-12', way: 9.95, cutoff: 10.00, bidCover: 2.15 },
  { date: '2026-08-27', way: 9.32, cutoff: 9.38, bidCover: 2.30 },
];

// ─── Upcoming Auctions ─────────────────────────────────────────────────
export const UPCOMING_AUCTIONS = [
  {
    id: 'AUC-KE-2026-W38-91',
    market: 'KE',
    issueNo: 'IFB1/2026/091',
    instrument: 'Kenya T-bill',
    tenorDays: 91,
    tenorLabel: '91-day',
    offerAmountLocal: 10000000000,
    currency: 'KES',
    auctionDate: '2026-09-17',
    bidDeadline: '2026-09-17T07:00:00Z', // 10:00 EAT
    settlementDate: '2026-09-21',
    auctionType: 'regular',
    lastResult: { way: 8.72, cutoff: 8.78, bidCover: 2.81, accepted: 9200000000 },
    history: YIELD_HISTORY_91,
  },
  {
    id: 'AUC-KE-2026-W38-182',
    market: 'KE',
    issueNo: 'IFB1/2026/182',
    instrument: 'Kenya T-bill',
    tenorDays: 182,
    tenorLabel: '182-day',
    offerAmountLocal: 15000000000,
    currency: 'KES',
    auctionDate: '2026-09-17',
    bidDeadline: '2026-09-17T07:00:00Z',
    settlementDate: '2026-09-21',
    auctionType: 'regular',
    lastResult: { way: 9.08, cutoff: 9.14, bidCover: 2.55, accepted: 14100000000 },
    history: YIELD_HISTORY_182,
  },
  {
    id: 'AUC-KE-2026-W38-364',
    market: 'KE',
    issueNo: 'IFB1/2026/364',
    instrument: 'Kenya T-bill',
    tenorDays: 364,
    tenorLabel: '364-day',
    offerAmountLocal: 20000000000,
    currency: 'KES',
    auctionDate: '2026-09-17',
    bidDeadline: '2026-09-17T07:00:00Z',
    settlementDate: '2026-09-21',
    auctionType: 'regular',
    lastResult: { way: 9.32, cutoff: 9.38, bidCover: 2.30, accepted: 18500000000 },
    history: YIELD_HISTORY_364,
  },
  {
    id: 'AUC-KE-2026-W40-91',
    market: 'KE',
    issueNo: 'IFB2/2026/091',
    instrument: 'Kenya T-bill',
    tenorDays: 91,
    tenorLabel: '91-day',
    offerAmountLocal: 10000000000,
    currency: 'KES',
    auctionDate: '2026-10-01',
    bidDeadline: '2026-10-01T07:00:00Z',
    settlementDate: '2026-10-05',
    auctionType: 'regular',
    lastResult: null,
    history: YIELD_HISTORY_91,
  },
  {
    id: 'AUC-KE-2026-SW01',
    market: 'KE',
    issueNo: 'SW1/2026/001',
    instrument: 'Kenya T-bill Switch',
    tenorDays: 182,
    tenorLabel: 'Switch 182-day',
    offerAmountLocal: 5000000000,
    currency: 'KES',
    auctionDate: '2026-09-24',
    bidDeadline: '2026-09-24T07:00:00Z',
    settlementDate: '2026-09-28',
    auctionType: 'switch',
    switchFrom: { tenor: 91, maturityDate: '2026-10-15' },
    lastResult: null,
    history: [],
  },
];

// ─── Auction Rules ─────────────────────────────────────────────────────
export const AUCTION_RULES_KENYA = {
  market: 'KE',
  minNonCompetitive: 50000,
  maxNonCompetitive: 50000000,
  minCompetitive: 2000000,
  denomination: 50000,
  withholdingTax: 15,
  paymentChannels: ['RTGS', 'EFT', 'M-Pesa', 'Bank Transfer'],
  mobileMoneyCap: 250000,
  bidDeadlineTime: '10:00 EAT',
  settlementCycle: 'T+2',
  dayCount: 'ACT/364',
};

// ─── Tickets ───────────────────────────────────────────────────────────
export const TICKETS = [
  {
    id: 'TKT-001', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-91',
    status: 'draft', createdAt: '2026-09-10T08:30:00Z', updatedAt: '2026-09-10T08:30:00Z',
    tranches: [{ type: 'non_competitive', amount: 5000000, yield: null }],
    hedgePlan: { ratio: 100, forwardRate: 132.80, tenorDays: 91 },
    rolloverInstruction: 'auto_same_tenor', fundingRoute: 'RTGS', netting: false,
    audit: [{ ts: '2026-09-10T08:30:00Z', action: 'created', by: 'system' }],
  },
  {
    id: 'TKT-002', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-182',
    status: 'pending_approval', createdAt: '2026-09-09T14:00:00Z', updatedAt: '2026-09-10T09:15:00Z',
    tranches: [{ type: 'non_competitive', amount: 10000000, yield: null }],
    hedgePlan: { ratio: 75, forwardRate: 134.20, tenorDays: 182 },
    rolloverInstruction: 'none', fundingRoute: 'RTGS', netting: false,
    approvals: [{ by: 'Sarah Ochieng', at: '2026-09-10T09:15:00Z', decision: 'pending' }],
    audit: [
      { ts: '2026-09-09T14:00:00Z', action: 'created', by: 'Michael Chen' },
      { ts: '2026-09-10T09:15:00Z', action: 'submitted_for_approval', by: 'Michael Chen' },
    ],
  },
  {
    id: 'TKT-003', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-364',
    status: 'approved', createdAt: '2026-09-08T10:00:00Z', updatedAt: '2026-09-09T16:00:00Z',
    tranches: [
      { type: 'competitive', amount: 15000000, yield: 9.35 },
      { type: 'non_competitive', amount: 5000000, yield: null },
    ],
    hedgePlan: { ratio: 100, forwardRate: 136.50, tenorDays: 364 },
    rolloverInstruction: 'auto_tenor:182', fundingRoute: 'RTGS', netting: true,
    approvals: [{ by: 'Sarah Ochieng', at: '2026-09-09T16:00:00Z', decision: 'approved' }],
    audit: [
      { ts: '2026-09-08T10:00:00Z', action: 'created', by: 'James Mwangi' },
      { ts: '2026-09-09T16:00:00Z', action: 'approved', by: 'Sarah Ochieng' },
    ],
  },
  {
    id: 'TKT-004', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-91',
    status: 'rejected', createdAt: '2026-09-07T09:00:00Z', updatedAt: '2026-09-08T11:30:00Z',
    tranches: [{ type: 'non_competitive', amount: 60000000, yield: null }],
    hedgePlan: { ratio: 50, forwardRate: 132.80, tenorDays: 91 },
    rolloverInstruction: 'none', fundingRoute: 'RTGS', netting: false,
    rejectionReason: 'Exceeds non-competitive limit of KES 50M',
    policyCheck: { passed: false, rule: 'max_non_competitive', message: 'Amount exceeds KES 50,000,000 non-competitive cap' },
    audit: [
      { ts: '2026-09-07T09:00:00Z', action: 'created', by: 'Michael Chen' },
      { ts: '2026-09-08T11:30:00Z', action: 'rejected', by: 'system:policy_engine' },
    ],
  },
  {
    id: 'TKT-005', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-182',
    status: 'submitted_to_csd', createdAt: '2026-09-06T08:00:00Z', updatedAt: '2026-09-10T07:05:00Z',
    csdRef: 'CBK-BID-2026-09-17-0042',
    tranches: [{ type: 'non_competitive', amount: 20000000, yield: null }],
    hedgePlan: { ratio: 100, forwardRate: 134.20, tenorDays: 182 },
    rolloverInstruction: 'auto_same_tenor', fundingRoute: 'RTGS', netting: true,
    audit: [
      { ts: '2026-09-06T08:00:00Z', action: 'created', by: 'James Mwangi' },
      { ts: '2026-09-10T07:05:00Z', action: 'submitted_to_csd', by: 'system:csd_gateway' },
    ],
  },
  {
    id: 'TKT-006', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-91',
    status: 'allocated', createdAt: '2026-09-01T08:00:00Z', updatedAt: '2026-09-04T14:00:00Z',
    csdRef: 'CBK-BID-2026-09-04-0018',
    tranches: [{ type: 'non_competitive', amount: 10000000, yield: null }],
    allocation: { amountAllocated: 10000000, fillPct: 100, acceptedYield: 8.72 },
    hedgePlan: { ratio: 100, forwardRate: 132.60, tenorDays: 91 },
    rolloverInstruction: 'auto_same_tenor', fundingRoute: 'RTGS', netting: false,
    audit: [
      { ts: '2026-09-01T08:00:00Z', action: 'created', by: 'James Mwangi' },
      { ts: '2026-09-04T14:00:00Z', action: 'allocated', by: 'system:csd_gateway' },
    ],
  },
  {
    id: 'TKT-007', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-364',
    status: 'partially_allocated', createdAt: '2026-08-25T10:00:00Z', updatedAt: '2026-08-28T14:00:00Z',
    csdRef: 'CBK-BID-2026-08-28-0055',
    tranches: [{ type: 'competitive', amount: 25000000, yield: 9.40 }],
    allocation: { amountAllocated: 15000000, fillPct: 60, acceptedYield: 9.38 },
    hedgePlan: { ratio: 100, forwardRate: 136.50, tenorDays: 364 },
    rolloverInstruction: 'none', fundingRoute: 'RTGS', netting: false,
    audit: [
      { ts: '2026-08-25T10:00:00Z', action: 'created', by: 'James Mwangi' },
      { ts: '2026-08-28T14:00:00Z', action: 'partially_allocated', by: 'system:csd_gateway' },
    ],
  },
  {
    id: 'TKT-008', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-182',
    status: 'unsuccessful', createdAt: '2026-08-20T10:00:00Z', updatedAt: '2026-08-24T14:00:00Z',
    csdRef: 'CBK-BID-2026-08-24-0031',
    tranches: [{ type: 'competitive', amount: 10000000, yield: 8.50 }],
    allocation: { amountAllocated: 0, fillPct: 0, acceptedYield: null },
    audit: [
      { ts: '2026-08-20T10:00:00Z', action: 'created', by: 'Michael Chen' },
      { ts: '2026-08-24T14:00:00Z', action: 'unsuccessful', by: 'system:csd_gateway' },
    ],
  },
  {
    id: 'TKT-009', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-91',
    status: 'payment_due', createdAt: '2026-08-28T08:00:00Z', updatedAt: '2026-09-02T10:00:00Z',
    csdRef: 'CBK-BID-2026-09-02-0012',
    tranches: [{ type: 'non_competitive', amount: 8000000, yield: null }],
    allocation: { amountAllocated: 8000000, fillPct: 100, acceptedYield: 8.75 },
    payment: { amountDue: 7806000, dueBy: '2026-09-11T07:00:00Z', channel: 'RTGS', nettingApplied: true, netPayable: 5806000 },
    audit: [
      { ts: '2026-08-28T08:00:00Z', action: 'created', by: 'Michael Chen' },
      { ts: '2026-09-02T10:00:00Z', action: 'payment_due', by: 'system:csd_gateway' },
    ],
  },
  {
    id: 'TKT-010', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-182',
    status: 'paid', createdAt: '2026-08-15T08:00:00Z', updatedAt: '2026-08-22T14:30:00Z',
    csdRef: 'CBK-BID-2026-08-21-0009',
    tranches: [{ type: 'non_competitive', amount: 12000000, yield: null }],
    allocation: { amountAllocated: 12000000, fillPct: 100, acceptedYield: 9.10 },
    payment: { amountDue: 11454000, dueBy: '2026-08-22T07:00:00Z', channel: 'RTGS', nettingApplied: false, netPayable: 11454000, paidAt: '2026-08-22T14:30:00Z' },
    audit: [
      { ts: '2026-08-15T08:00:00Z', action: 'created', by: 'James Mwangi' },
      { ts: '2026-08-22T14:30:00Z', action: 'paid', by: 'treasury_ops' },
    ],
  },
  {
    id: 'TKT-011', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-364',
    status: 'settled', createdAt: '2026-07-01T08:00:00Z', updatedAt: '2026-07-10T16:00:00Z',
    csdRef: 'CBK-BID-2026-07-08-0003',
    tranches: [{ type: 'non_competitive', amount: 15000000, yield: null }],
    allocation: { amountAllocated: 15000000, fillPct: 100, acceptedYield: 9.50 },
    payment: { amountDue: 13575000, dueBy: '2026-07-09T07:00:00Z', channel: 'RTGS', nettingApplied: false, netPayable: 13575000, paidAt: '2026-07-09T10:00:00Z' },
    settlement: { settledAt: '2026-07-10T16:00:00Z', csdSettlementRef: 'CBK-SET-2026-07-10-0003' },
    audit: [
      { ts: '2026-07-01T08:00:00Z', action: 'created', by: 'James Mwangi' },
      { ts: '2026-07-10T16:00:00Z', action: 'settled', by: 'system:csd_gateway' },
    ],
  },
  {
    id: 'TKT-012', entityId: 'ENT-001', auctionId: 'AUC-KE-2026-W38-91',
    status: 'cancelled', createdAt: '2026-09-05T10:00:00Z', updatedAt: '2026-09-05T11:00:00Z',
    tranches: [{ type: 'non_competitive', amount: 3000000, yield: null }],
    cancelReason: 'Duplicate entry — ticket recreated as TKT-006',
    audit: [
      { ts: '2026-09-05T10:00:00Z', action: 'created', by: 'Michael Chen' },
      { ts: '2026-09-05T11:00:00Z', action: 'cancelled', by: 'Michael Chen' },
    ],
  },
  {
    id: 'TKT-013', entityId: 'ENT-003', auctionId: 'AUC-KE-2026-W38-91',
    status: 'pending_approval', createdAt: '2026-09-10T12:00:00Z', updatedAt: '2026-09-10T12:00:00Z',
    tranches: [{ type: 'non_competitive', amount: 500000, yield: null }],
    hedgePlan: { ratio: 100, forwardRate: 132.80, tenorDays: 91 },
    rolloverInstruction: 'auto_same_tenor', fundingRoute: 'M-Pesa', netting: false,
    approvals: [
      { by: 'Level 1 Auto', at: '2026-09-10T12:01:00Z', decision: 'approved' },
      { by: 'Level 2 Manual', at: null, decision: 'pending' },
    ],
    audit: [
      { ts: '2026-09-10T12:00:00Z', action: 'created', by: 'Michael Chen' },
      { ts: '2026-09-10T12:01:00Z', action: 'l1_auto_approved', by: 'system:policy_engine' },
    ],
  },
];

// ─── Repatriations ─────────────────────────────────────────────────────
export const REPATRIATIONS = [
  {
    id: 'REP-001',
    entityId: 'ENT-001',
    positionId: 'POS-KE-091-001',
    market: 'KE',
    faceAmount: 15000000,
    currency: 'KES',
    maturityDate: '2026-09-15',
    stage: 'wht_confirmed',
    stages: [
      { key: 'maturity_pending', label: 'Maturity Pending', completedAt: '2026-09-10T00:00:00Z' },
      { key: 'matured', label: 'Matured', completedAt: '2026-09-15T00:00:00Z' },
      { key: 'wht_confirmed', label: 'WHT Confirmed', completedAt: '2026-09-15T10:00:00Z' },
      { key: 'forward_settled', label: 'Forward Settled', completedAt: null },
      { key: 'fx_out_booked', label: 'Foreign-Exchange-Out Booked', completedAt: null },
      { key: 'fx_out_settled', label: 'Foreign-Exchange-Out Settled', completedAt: null },
      { key: 'arrived', label: 'Arrived', completedAt: null },
    ],
    whtAmount: 196575,
    netProceeds: 15000000,
    fxOutRate: null,
    fxMidRate: 131.20,
    expectedUsd: null,
    blockers: [],
    daysToCashHome: 5,
  },
  {
    id: 'REP-002',
    entityId: 'ENT-001',
    positionId: 'POS-KE-182-002',
    market: 'KE',
    faceAmount: 20000000,
    currency: 'KES',
    maturityDate: '2026-09-22',
    stage: 'maturity_pending',
    stages: [
      { key: 'maturity_pending', label: 'Maturity Pending', completedAt: null },
      { key: 'matured', label: 'Matured', completedAt: null },
      { key: 'wht_confirmed', label: 'WHT Confirmed', completedAt: null },
      { key: 'forward_settled', label: 'Forward Settled', completedAt: null },
      { key: 'fx_out_booked', label: 'Foreign-Exchange-Out Booked', completedAt: null },
      { key: 'fx_out_settled', label: 'Foreign-Exchange-Out Settled', completedAt: null },
      { key: 'arrived', label: 'Arrived', completedAt: null },
    ],
    whtAmount: null,
    netProceeds: null,
    fxOutRate: null,
    fxMidRate: 131.20,
    expectedUsd: 152439,
    blockers: [{ type: 'pending_forward', message: 'Forward contract not yet struck — awaiting foreign exchange desk confirmation' }],
    daysToCashHome: 12,
  },
];

// ─── Market Context (Kenya) ────────────────────────────────────────────
export const MARKET_CONTEXT_KENYA = {
  market: 'KE',
  policyRate: 10.0,
  policyRateDate: '2026-08-06',
  spotRate: 131.20,
  spotCurrencyPair: 'KES/USD',
  forwardCurve: [
    { tenor: '1M', rate: 131.65, points: 45 },
    { tenor: '2M', rate: 132.10, points: 90 },
    { tenor: '3M', rate: 132.80, points: 160 },
    { tenor: '6M', rate: 134.20, points: 300 },
    { tenor: '9M', rate: 135.50, points: 430 },
    { tenor: '12M', rate: 136.90, points: 570 },
  ],
  sovereignRisk: {
    rating: 'B+ (S&P)',
    outlook: 'Stable',
    cdsSpread: 385,
    debtToGdp: 68.2,
    inflationYoy: 4.8,
    currentAccount: -4.2,
    summary: 'Kenya maintains B+ rating with stable outlook. Fiscal consolidation on track. T-bill yields declining as CBK eases monetary policy amid moderating inflation.',
  },
};

// ─── Rollover Instructions ─────────────────────────────────────────────
export const ROLLOVER_INSTRUCTIONS = [
  { positionId: 'POS-KE-091-001', entityId: 'ENT-001', tenor: 91, maturityDate: '2026-09-15', faceAmount: 15000000, instruction: 'auto_same_tenor' },
  { positionId: 'POS-KE-182-002', entityId: 'ENT-001', tenor: 182, maturityDate: '2026-09-22', faceAmount: 20000000, instruction: 'none' },
  { positionId: 'POS-KE-364-003', entityId: 'ENT-001', tenor: 364, maturityDate: '2026-12-15', faceAmount: 25000000, instruction: 'auto_tenor:182' },
  { positionId: 'POS-KE-091-004', entityId: 'ENT-001', tenor: 91, maturityDate: '2027-01-10', faceAmount: 10000000, instruction: 'principal_only' },
  { positionId: 'POS-KE-091-005', entityId: 'ENT-003', tenor: 91, maturityDate: '2026-10-20', faceAmount: 3000000, instruction: 'auto_same_tenor' },
  { positionId: 'POS-KE-182-006', entityId: 'ENT-003', tenor: 182, maturityDate: '2026-12-05', faceAmount: 5500000, instruction: 'none' },
];

// ─── Onboarding Steps ──────────────────────────────────────────────────
export const ONBOARDING_STEPS = [
  { key: 'identity_docs', label: 'Identity Documents', description: 'Upload passport/ID and proof of address', owner: 'investor', actionLabel: 'Upload Documents' },
  { key: 'tax_id', label: 'Tax Identification', description: 'Provide KRA PIN or foreign tax ID', owner: 'investor', actionLabel: 'Enter Tax ID' },
  { key: 'local_mobile', label: 'Local Mobile Number', description: 'Register a Kenyan mobile number for M-Pesa settlement', owner: 'investor', actionLabel: 'Register Number' },
  { key: 'settlement_account', label: 'Settlement Account', description: 'Link a Kenyan bank account for RTGS settlement', owner: 'investor', actionLabel: 'Link Account' },
  { key: 'csd_application', label: 'CSD Application', description: 'Forwardsflow submits DhowCSD application on your behalf', owner: 'forwardsflow', actionLabel: 'Submit Application' },
  { key: 'csd_token_verified', label: 'CSD Token Verified', description: 'DhowCSD token received and verified', owner: 'forwardsflow', actionLabel: 'Verify Token' },
];

// Step completion per account
export const ONBOARDING_PROGRESS = {
  'CSD-KE-001': {
    identity_docs: 'completed',
    tax_id: 'completed',
    local_mobile: 'completed',
    settlement_account: 'completed',
    csd_application: 'completed',
    csd_token_verified: 'completed',
  },
  'CSD-KE-002': {
    identity_docs: 'completed',
    tax_id: 'completed',
    local_mobile: 'pending',
    settlement_account: 'pending',
    csd_application: 'pending',
    csd_token_verified: 'pending',
  },
  'CSD-KE-003': {
    identity_docs: 'completed',
    tax_id: 'completed',
    local_mobile: 'blocked',
    settlement_account: 'pending',
    csd_application: 'pending',
    csd_token_verified: 'pending',
  },
  'CSD-KE-004': {
    identity_docs: 'completed',
    tax_id: 'completed',
    local_mobile: 'completed',
    settlement_account: 'completed',
    csd_application: 'completed',
    csd_token_verified: 'completed',
  },
};
